// extracted by mini-css-extract-plugin
module.exports = {"Tag":"ProjectTag_Tag__3ehHJ"};